import { register } from '@shopify/theme-sections'
import {renderAccordions} from '../modules/detail-accordion'

import '../../styles/sections/section-accordion-right.scss'

export default register(`section-accordion-right`, {
  onLoad() {
    renderAccordions(`section-accordion-right`, false)
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})

